import { useMediaQuery } from 'react-responsive'

/**
 * Custom hook used to get media queries breakpoints
 * @returns object with each media query. isDesktop | isTablet | isMobile
 */
export const useGetBreakpoints = () => {
    const isDesktop = useMediaQuery({ minWidth: 991 });
    const isTablet = useMediaQuery({ minWidth: 767, maxWidth: 991 });
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return {
        isDesktop,
        isTablet,
        isMobile,
    }
}

